"use client";
import { DescriptionLink } from "@/components/CTA/variants/MultiCourse/descriptions/DescriptionLink";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import useTranslations from "@/i18n/useTranslations";

export default function SharpenDescription() {
  const t = useTranslations("MultiCourse");
  let pos = 0;
  return (
    <ClientOnly>
      <div>
        <p>
          <DescriptionLink
            url="/certificates/professional-certificate"
            text="Professional certificates"
            visibleText={t("professionalCertificates")}
            position={`${++pos}`}
            variant="professional-certificate"
          />
          &nbsp;{t("sharpenIntroRest")}
        </p>
        <ul className="list-disc mb-4">
          <li>{t("sharpenBullet1")}</li>
          <li>{t("sharpenBullet2")}</li>
          <li>{t("sharpenBullet3")}</li>
          <li>{t("sharpenBullet4")}</li>
        </ul>
        <p>
          <i>{t("honingLeadership")} </i>
          <DescriptionLink
            url="/executive-education"
            text="executive education programs"
            visibleText={t("executiveEducationPrograms")}
            position={`${++pos}`}
            variant="executive-education-2u"
          />
          <b>
            <i>.</i>
          </b>
        </p>
      </div>
    </ClientOnly>
  );
}
